import { PageFrame } from '../../components/PageFrame';
import { SafeExitLink } from './SafeExitLink';

// S-SCR-007 Completion: same minimalism as PausedState/EndEarlyState — a
// pure terminal-state screen with no props. The session is already
// confirmed complete by the time PracticeTask's Task 1 routing hands off
// here, so there is nothing to record on mount and no reason to call
// getCurrentPractice() — no item content or progress numbers are fetched
// or rendered here at all.
//
// Copy is deliberately calm per the controlling prompt (§10.7: "calm
// acknowledgement, no inflated reward, ranking, streak or next unapproved
// activity"). No emoji, no point totals, no streak counters, no
// items-completed/items-total scoreboard, and no "start another activity"
// affordance — this pack has no next-activity concept; a new entry code
// from the teacher is how a learner starts anything new, which is existing
// T-SCR-006 scope, not this screen's job.
export function CompletionState() {
  return (
    <PageFrame title="Your activity" audience="learner">
      {/* A calm visual acknowledgement: a soft tick badge, no confetti,
          points or streaks (same §10.7 limits as the copy). */}
      <div className="mt-6 grid justify-items-center gap-4 text-center">
        <span
          aria-hidden="true"
          className="grid size-20 place-items-center rounded-full bg-mint ring-8 ring-mint/40"
        >
          <svg
            viewBox="0 0 24 24"
            className="size-10 text-forest-800"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M5 12.5l4.5 4.5L19 7.5" />
          </svg>
        </span>
        <p className="text-lg leading-relaxed text-ink-soft">
          You've finished your activity. Nice work.
        </p>
      </div>

      <SafeExitLink />
    </PageFrame>
  );
}
